import { Outlet } from 'react-router';
import Box from '@mui/material/Box';

export function AppLayout() {
    return (
        <Box component="main" sx={{ overflow: 'auto' }}>
            {/* Main */}
            <Outlet />
        </Box>
    );
}
